import React from "react";
import CardDetails from "./carddetail";

const Card = ({ list, product, handleonClick }) => {
  return list.map((item) => {
    let objL1 = JSON.parse(item.L1);
    let objL2 = JSON.parse(item.L2);
    let objL3 = JSON.parse(item.L3);
    let objL4 = JSON.parse(item.L4);
    let objL5 = JSON.parse(item.L5);
    let objL6 = JSON.parse(item.L6);
    let objL7 = JSON.parse(item.L7);
    let objL8 = JSON.parse(item.L8);
    let objL9 = JSON.parse(item.L9);
    let objL10 = JSON.parse(item.L10);
    let objC1 = JSON.parse(item.C1);
    let objC2 = JSON.parse(item.C2);
    let objC3 = JSON.parse(item.C3);
    let objC4 = JSON.parse(item.C4);
    let objC5 = JSON.parse(item.C5);
    let objB1 = JSON.parse(item.B1);
    let objB2 = JSON.parse(item.B2);
    let objB3 = JSON.parse(item.B3);
    let objB4 = JSON.parse(item.B4);
    let objB5 = JSON.parse(item.B5);
    return (
      <div  key={item.HOUR}>
        <div className="row">
          {item && item.CUR === item.HOUR ? (
            <div
            style={{ width: 50, height: 30, fontSize: "14px" }}
            className="col-xs-1   bg-primary border border-muted text-light  border-bottom-0 border-right-0"
           
            >
              <div className="justify-content-center
          ">
                {item.HOUR}
                {":00"}
              </div>
            </div>
          ) : (
            <div
            style={{ width: 50, height: 30, fontSize: "14px" }}
            className="col-xs-1   bg-secondary border border-muted text-light  border-bottom-0 border-right-0"
            >
              <div className="justify-content-center
          ">
                {item.HOUR}
                {":00"}
              </div>
            </div>
          )}

          {(product == 0 || product == 2) && (
            <>
              <CardDetails list={objL1} handleonClick={handleonClick} />
              <CardDetails list={objL2} handleonClick={handleonClick} />
              <CardDetails list={objL3} handleonClick={handleonClick} />
              <CardDetails list={objL4} handleonClick={handleonClick} />
              <CardDetails list={objL5} handleonClick={handleonClick} />
              <CardDetails list={objL6} handleonClick={handleonClick} />
              <CardDetails list={objL7} handleonClick={handleonClick} />
              <CardDetails list={objL8} handleonClick={handleonClick} />
              <CardDetails list={objL9} handleonClick={handleonClick} />

              {product == 2 ? (
                <CardDetails
                  list={objL10}
                  className="col-xs-1  card-body border border-secondary border-bottom-0"
                  handleonClick={handleonClick}
                />
              ) : (
                <CardDetails list={objL10} handleonClick={handleonClick} />
              )}
            </>
          )}

          {(product == 0 || product == 1) && (
            <>
              <CardDetails list={objC1} handleonClick={handleonClick} />
              <CardDetails list={objC2} handleonClick={handleonClick} />
              <CardDetails list={objC3} handleonClick={handleonClick} />
              <CardDetails list={objC4} handleonClick={handleonClick} />
              {product == 1 ? (
                <CardDetails
                  list={objC5}
                  className="col-xs-1  card-body border border-secondary border-bottom-0"
                  handleonClick={handleonClick}
                />
              ) : (
                <CardDetails list={objC5} handleonClick={handleonClick} />
              )}
            </>
          )}

          {(product == 0 || product == 3) && (
            <>
              <CardDetails list={objB1} handleonClick={handleonClick} />
              <CardDetails list={objB2} handleonClick={handleonClick} />
              <CardDetails list={objB3} handleonClick={handleonClick} />
              <CardDetails list={objB4} handleonClick={handleonClick} />
              <CardDetails
                list={objB5}
                handleonClick={handleonClick}
                className="col-xs-1  card-body border border-secondary border-bottom-0"
              />
            </>
          )}
        </div>
      </div>
    );
  });
};

export default Card;
